module.exports = __webpack_public_path__ + "img/avatar.3ac88a09.png";